import React from 'react';
import Check from '@mui/icons-material/Check';

interface Props {
  checked?: boolean;
}

const IconCheckbox: React.FC<Props> = ({ checked }) => {
  return <div className="icon">{checked && <Check />}</div>;
};

export default IconCheckbox;
